'use client';

import { NhostSession } from '@nhost/hasura-auth-js';
// import { useInterpret } from '@xstate/react';
import React, {
  createContext,
  // PropsWithChildren,
  useEffect,
  useRef,
} from 'react';
import { KaktuAuthClient } from '..';

export const AuthContext = createContext<KaktuAuthClient>(
  {} as KaktuAuthClient,
);

export interface KaktuProviderProps {
  auth: KaktuAuthClient;
  initial?: NhostSession;
  children: React.ReactNode;
}

export function AuthProvider({
  auth,
  initial,
  ...props
}: KaktuProviderProps) {
  // * Hook to send session update everytime the 'initial' props changed
  const isInitialMount = useRef(true);
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else if (initial) {
      auth.client.interpreter?.send('SESSION_UPDATE', { data: { session: initial } });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initial]);

  return (
    <AuthContext.Provider value={auth}>{props.children}</AuthContext.Provider>
  );
}
